export const Role = {
  PERSON: 'person',
  ORGANIZATION: 'organization',
  FOREIGN_ORGANIZATION: 'foreignOrganization',
  BUSINESSMAN: 'businessman',
  // роль не определена
  ANONYMOUSE: 'anonymouse',
} as const;

export type RoleValues = typeof Role[keyof typeof Role];

// получаем от бека такие роли
export const RoleTypeAuth = {
  PERSON: 'PERSON',
  AGENCY: 'AGENCY', // ОГВ
  LEGAL: 'LEGAL', // организация
  BUSINESS: 'BUSINESS',
};

// мапим в роли используемые на проекте
export const RoleTypeAuthMap = {
  PERSON: Role.PERSON,
  AGENCY: Role.ORGANIZATION,
  LEGAL: Role.ORGANIZATION,
  BUSINESS: Role.BUSINESSMAN,
};

export const JobPlaceDictionary = {
  ORGANIZATION: 'Работает на организацию',
  BUSINESSMAN: 'Работает на индивидуального предпринимателя',
  IS_BUSINESSMAN: 'Является индивидуальным предпринимателем',
  WORK_UNKNOWN: 'Место работы неизвестно',
};

export const Gender = {
  M: 'Мужской',
  F: 'Женский',
};

export const NotificationType = {
  NOTIFICATION: 'notification',
  NOTIFICATION_DOCUMENT: 'notification-document',
};
